import React, {useContext} from 'react'
import AlertContext from '../../context/alert/alertContext';
import {isBrowser, isMobile } from 'react-device-detect';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { removeAlert } from '../../context/alert/AlertState';

const Alerts = () => {
    const alertContext = useContext(AlertContext)
   
    return (
        alertContext.alerts.length > 0 && alertContext.alerts.map(alert => (
            alert.display === 'popup' ? (
                <Dialog
                    key={alert.id}
                    className="pop-up pop-up-orange"
                    title="שימ/י לב:"
                    onClose={() => removeAlert(alertContext.dispatch, alert.id)}>
                    <p>{alert.msg}</p>
                    <br />
                    <p>נא לתאם מול המשרד בטלפון שמספרו 08-6510080</p>
                    <p>או בווטסאפ שמספרו 050-9784007</p>
                    <br />
                    <p>לשרותך,</p>
                    <p>צוות עדהגן</p>
                    <DialogActionsBar>
                        <button
                            className="submit btn"
                            onClick={() => removeAlert(alertContext.dispatch, alert.id)}>
                            אישור
                        </button>
                    </DialogActionsBar>
                </Dialog>
            ) :
            <div key={alert.id} className={`alert alert-${alert.type} alert-mobile-${isMobile}`}>
                <i className='fas fa-info-circle' /> {alert.msg}
            </div>
        ))
    )
}

export default Alerts
